import React, { useState, useEffect } from 'react';

const LedgerSubReportPrint = () => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [params, setParams] = useState({});
  const [grandTotal, setGrandTotal]=useState([]);

  // Get URL parameters or use defaults
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const extractedParams = {
     
      supplierCode: urlParams.get('supplierCode') || '%',
      branch: urlParams.get('branch') || '8',
      from:urlParams.get('from') || '',
      to:urlParams.get('to') ||''

    };
    setParams(extractedParams);
  }, []);

  // Sample data structure matching your API response
  
  // Fetch data from API
  useEffect(() => {
    const fetchReportData = async () => {
      try {
        setLoading(true);
        

        
        console.log("API Params:", params);
        
         const queryParams = new URLSearchParams(params).toString();
const apiUrl = `http://nissi-india.com/api/grnSupplier_ledgerInside?${queryParams}`;

        const response = await fetch(apiUrl);
    
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        console.log("API Response:", data);

        
        if (!data.success) {
          throw new Error('API returned unsuccessful response');
        }

        // Transform API data to match component structure
        const apiData = data.data || [];
        
       const transformedData = {
        success: data.success,
        branchName: apiData.length > 0 ? apiData[0].fld_branchname : "Branch 8",
        fromDate: params.from,
        toDate: params.to,
        totalItems: apiData.length,
        items: apiData.map((item, index) => ({
          sNo: index + 1,
          invno: item.invno,
          fld_InvoiceDate: item.fld_InvoiceDate,
          Credit: item.Credit,
          Credit_New: item.Credit_New,
          Debit: item.Debit,
          Debit_New: item.Debit_New,
          Cl_Balance: item.Cl_Balance,
          Cl_Balance_New: item.Cl_Balance_New,
          fld_grnno: item.fld_grnno,
          fld_Mobile: item.fld_Mobile,
        })),
      };
         
        

        setReportData(transformedData);
        setError(null);
        
      } catch (err) {
        console.error('Error fetching stock summary report data:', err);
        setError(err.message);
        setReportData();
      } finally {
        setLoading(false);
      }
    };

    if (Object.keys(params).length > 0) {
      fetchReportData();
    }
  }, [params]);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    }).format(value).replace('₹', '₹ ');
  };


  if (loading) {
    return (
      <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading stock summary report...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!reportData) {
    return (
      <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center text-red-600">
            <p className="text-lg font-semibold mb-2">Error Loading Report</p>
            <p>{error || "Failed to load stock summary report"}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
      {/* API Error Warning */}
      {error && (
        <div className="mb-4 p-3 bg-yellow-100 border border-yellow-400 text-yellow-700 rounded no-print">
          <p className="text-sm">
            <strong>Note:</strong> Using sample data due to API error. ({error})
          </p>
        </div>
      )}

      {/* Outer Border */}
      <div className="border-4 border-black p-4 print:border-black">
        
        {/* Header Section */}
        <div className="border-2 border-black mb-4 print:border-black">
          <div className="flex items-start p-4">
            {/* Logo Section */}
            <div className="w-32 h-20 border-2 border-black mr-6 flex items-center justify-center bg-white">
              <div className="text-center">
                <div className="w-12 h-8 bg-black mx-auto mb-1 flex items-center justify-center">
                  <span className="text-white text-xs font-bold">LOGO</span>
                </div>
                <div className="text-xs font-bold">NISSI INFOTECH</div>
                <div className="text-xs">PVT LTD</div>
              </div>
            </div>
            
            {/* Company Info */}
            <div className="flex-1 text-center">
              <h1 className="text-xl font-bold mb-1">Nissi Infotech</h1>
              <p className="text-sm mb-1">NISSI</p>
              <p className="text-sm font-bold mb-1">CIVIL CONSTRUCTION</p>
              <p className="text-xs mb-2">
                3/42-12, Nagappa colony, kavundampai,644003,Tamil Nadu,India,<br/>
                Phone No :9003744644 infraconsoft-implementation@nissiinfotech.in
              </p>
              <div className="border-2 border-black p-1 inline-block">
                <h2 className="text-lg font-bold">LEDGER SUB REPORT</h2>
              </div>
            </div>

            {/* Screen Info */}
           
          </div>
        </div>

        {/* Report Parameters */}
       

        {/* Main Table */}
        <div className="border-2 border-black mb-4 print:border-black">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-gray-100 print:bg-white">
                <th className="border border-black px-2 py-2 text-center print:border-black">SNo</th>
                <th className="border border-black px-2 py-2 text-center print:border-black">Inv No</th>
                <th className="border border-black px-2 py-2 text-center print:border-black">Inv Date</th>
                <th className="border border-black px-2 py-2 text-center print:border-black">Credit</th>
                <th className="border border-black px-2 py-2 text-center print:border-black">Debit</th>
                <th className="border border-black px-2 py-2 text-center print:border-black">CL. Balance</th>
              </tr>
            </thead>
            <tbody>
              {reportData.items.map((item) => (
                <tr key={item.sNo}>
                  <td className="border border-black px-2 py-1 text-center print:border-black">{item.sNo}</td>
                  <td className="border border-black px-2 py-1 text-center print:border-black">{item.invno}</td>
                  <td className="border border-black px-2 py-1 text-left print:border-black">{item.fld_InvoiceDate}</td>
                  <td className="border border-black px-2 py-1 text-center print:border-black">{item.Credit_New}</td>
                  <td className="border border-black px-2 py-1 text-center print:border-black">{item.Debit_New}</td>
                  <td className="border border-black px-2 py-1 text-right print:border-black">{item.Cl_Balance_New}</td>
                </tr>
              ))}

              {/* Total Row */}
              <tr className="bg-gray-100 print:bg-white font-bold">
                
                <td className="border border-black px-2 py-1 text-right print:border-black">{formatCurrency(grandTotal)}</td>
              </tr>

              {/* No Data Message */}
              {reportData.items.length === 0 && (
                <tr>
                  <td className="border border-black px-2 py-8 text-center print:border-black" colSpan="8">
                    <div className="text-gray-500">
                      No stock records found for the specified criteria
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="border-2 border-black print:border-black">
          <div className="p-2 text-right text-xs">
            <span className="font-bold">Page 1 of 1</span>
          </div>
          <div className="border-t-2 border-black p-2 text-xs print:border-black">
            Report generated by ERP-Software - www.infraconsoft.com owned by <span className="font-bold">www.nissiinfotech.com</span>
          </div>
        </div>

      </div>

      {/* Control Buttons */}
      <div className="mt-6 text-center no-print">
        <button
          onClick={() => window.print()}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors mr-4"
        >
          Print Report
        </button>
        <button
          onClick={() => window.location.reload()}
          className="bg-gray-600 text-white px-6 py-2 rounded hover:bg-gray-700 transition-colors mr-4"
        >
          Refresh Data
        </button>
        <button
          onClick={() => window.close()}
          className="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700 transition-colors"
        >
          Close Window
        </button>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          .no-print {
            display: none !important;
          }
          body {
            margin: 0;
            padding: 10mm;
            background: white !important;
          }
          * {
            color: black !important;
            background: white !important;
            border-color: black !important;
          }
          .print\\:border-black {
            border-color: black !important;
          }
          .print\\:bg-white {
            background-color: white !important;
          }
          table {
            font-size: 7px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default LedgerSubReportPrint;